import { useEffect, useState } from 'react';
import { getPageContent } from '../../helpers/content';
import NavigationBar from '../../components/NavigationBar/NavigationBar'
import PageHeaderView from '../../components/PageHeaderView/PageHeaderView';
import FindUsSection from '../../components/FindUsSection/FindUsSection';
import ReactMarkdown from "react-markdown";

import { offWhite, gray } from '../../helpers/colors';
import PageSection from '../../components/PageSection/PageSection';
import "./VolunteeringPage.css"

const VolunteeringPage = () => {

  const [content, setContent] = useState(null);

  useEffect(() => {
    document.title = 'Volunteering';
    getPageContent('VolunteeringPage').then(r => setContent(r))
  }, []);

  if (!content) {
    return <p>loading...</p>;
  }

  return (
    <>
      <NavigationBar currentPage={3}/>
      <PageHeaderView
        image={content.image}
        title={content.title}
        col1Text={content.col1Text}
      />

      <PageSection
        sectionTitle={content.section1Title}
        backgroundColor={gray}
        foregroundColor={offWhite}
      >
        <div style={{textAlign: "left"}}>
          <ReactMarkdown>
            {content.section1Text}
          </ReactMarkdown>
          <div className="volenteer-images">
            {content.section1Images.map((image, i) => (
              <img key={i} className="volunteering-section-image" src={image.src} alt={image.alt} />
            ))}
          </div>
          <br/><br/>
        </div>
      </PageSection>

      <PageSection
        sectionTitle={content.section2Title}
        backgroundColor={offWhite}
        foregroundColor={gray}
      >
        <div style={{textAlign: "left"}}>
          <ReactMarkdown className='display-linebreak'>
            {content.section2Text}
          </ReactMarkdown>
        </div>
      </PageSection>

      <PageSection
        sectionTitle={content.section3Title}
        backgroundColor={offWhite}
        foregroundColor={gray}
      >
        <div style={{textAlign: "left"}}>
          <ReactMarkdown className='display-linebreak'>
            {content.section3Text}
          </ReactMarkdown>
        </div>
      </PageSection>

      <PageSection
        sectionTitle={content.section4Title}
        backgroundColor={gray}
        foregroundColor={offWhite}
      >
        <div style={{textAlign: "left"}}>
          <ReactMarkdown className='display-linebreak'>
            {content.section4Text}
          </ReactMarkdown>
          <br/>
          <div className="volenteer-images">
            {content.section4Images.map((image, i) => (
              <img key={i} className="volunteering-section-image" src={image.src} alt={image.alt} />
            ))}
          </div>
          <br/><br/>
        </div>
      </PageSection>

      <PageSection
        sectionTitle={content.section5Title}
        backgroundColor={offWhite}
        foregroundColor={gray}
      >
        <div style={{textAlign: "left"}}>
          <ReactMarkdown className='display-linebreakh'>
            {content.section5Text}
          </ReactMarkdown>
        </div>
      </PageSection>

      <PageSection
        sectionTitle={content.section6Title}
        backgroundColor={offWhite}
        foregroundColor={gray}
      >
        <div style={{textAlign: "left"}}>
          <ReactMarkdown className='display-linebreakh'>
            {content.section6Text}
          </ReactMarkdown>
          <a className="contact-darren" href="mailto:darren@act-tanzania.org?subject=Volunteering Inquiry&body=Hi, I am interested in volunteering with ACT Tanzania. Please provide me with more information about the opportunities available. Thank you!">
            darren@act-tanzania.org
          </a>

          <br/><br/>
          <ReactMarkdown className='display-linebreakh'>
            {content.section6Text2}
          </ReactMarkdown>
          <br/>
          <img className="volunteering-section-image" src={content.section6Image.src} alt={content.section6Image.alt} />
        </div>
      </PageSection>
      <FindUsSection />
    </>
  )

}

export default VolunteeringPage
